



































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component
export default class DropZone extends Vue {

    @Prop({default: true})
    private enabled!: boolean;

    @Prop({default: 0})
    private increment!: number;

    private highlight = false;

    private fileName = '';
    openFileSelection(): void {
        if (!this.enabled) return;
        (<HTMLElement>this.$refs.fileInput).click();
    }

    onDragOver(event: DragEvent): void {
        if (!this.enabled) return;
        event.preventDefault();
        this.highlight = true;
    }

    onDragLeave(event: DragEvent): void {
        this.highlight = false;
    }

    onDrop(event: DragEvent): void {
        if (!this.enabled) return;
        event.preventDefault();
        const files = event.dataTransfer!.files;
        let result: File[] = [];
        for (var i = 0; i < files.length; i++) {
            result.push(<File>files.item(i));
        }
        if(result.length > 0) {
            this.fileName = result[0].name
            this.$emit('filesAdded', result);
            this.highlight = false;
        }
    }

    onFileChanged(event: any) {
        let files: FileList = event.target.files;
        let result: File[] = [];
        for (var i = 0; i < files.length; i++) {
            result.push(<File>files.item(i));
        }
        if(result.length > 0){
            this.fileName = result[0].name
            this.$emit('filesAdded', result);
        }
    }

    @Watch('increment')
    onChangeIncrement() {
        (this.$refs.fileInput as any).value=null;
        this.fileName = ''
    }
}
